import React from 'react';

import { BrandColor } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import { BodyText } from '../../ui';
import { TopProIcon } from './TopProIcon';

export const DeprecatedTopProBadge = () => (
  <Box
    color={BrandColor.LightPurple}
    borderRadius={4}
    left={6}
    top={2}
    testID="ss-top-pro"
    dataSet={{
      event: 'ss-top-pro',
    }}
  >
    <Inline
      space={2}
      alignItems="center"
      justifyContent="center"
      paddingY={2}
      paddingX={8}
    >
      <Box testID="ss-top-pro-icon">
        <TopProIcon width={20} height={20} active />
      </Box>
      <BodyText
        appearance="small"
        weight="bold"
        color={BrandColor.BackInBlack}
        testID="ss-top-pro-text"
      >
        Top Pro
      </BodyText>
    </Inline>
  </Box>
);
